import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import apiClient from '../../global/utils/apiClient'
import { useMetaStore } from './MetaStore'

export const useGolferStore = create()(
  persist(
    (set, get) => ({
      golfer: get()?.golfer || {},
      setGolfer: (golfer) => set({ golfer }),
      golfers: get()?.golfers || [],
      setGolfers: (golfers) => set({ golfers }),
      group: get()?.group || [],
      setGroup: (group) => set({ group }),
      groupRounds: get()?.groupRounds || [],
      setGroupRounds: (groupRounds) => set({ groupRounds }),
      roundGolferMap: get()?.roundGolferMap || {},
      setRoundGolferMap: (roundGolferMap) => set({ roundGolferMap }),
      populateActiveGolfers: async (forceRefresh = false, noCache = false) => {
        try {
          if (get().golfers?.length > 0 && !forceRefresh && !noCache) {
            return
          }

          const url = `/gskapi/golfers/activegolfers/${useMetaStore.getState().orgId}${noCache ? '?noCache=true' : ''}`
          const activeGolfers = await apiClient.get(url)
          let tmpMap = {}
          for (const g of activeGolfers.data) {
            tmpMap[g.golferId] = g
          }

          get().setRoundGolferMap(tmpMap)
          get().setGolfers(activeGolfers.data)
        } catch (error) {
          console.error('Error fetching golfers:', error)
        }
      },
    }),
    {
      name: 'gsk-golfer',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
